const styles = () => ({

	root: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		flexWrap: 'nowrap',
	},

	workspace: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		position: 'relative',
	},

	list: {
		width: '100%',
		height: '100%',
		paddingLeft: 21,
		paddingRight: 21,
		display: 'flex',
		flexDirection: 'column',
	},

	details: {
		maxWidth: '350px',
		minWidth: '350px',
		overflowY: 'auto',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			width: '1px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '21px',
			boxShadow: 'inset 0 0 21px rgba(0,0,0,.3)', 
		},
		background: '#FAFAFA 0% 0% no-repeat padding-box',
		boxShadow: '0px 3px 6px #00000029',
		padding: '0 21px',
		boxSizing: 'border-box',
	},

	drawer: {
		height: '100%',
		maxWidth: '350px',
		minWidth: '350px',
		paddingRight: 21,
	},

	title: {
		fontSize: '20px',
		marginRight: '20px',
	},

	searchbar: {
		display: 'flex',
		alignItems: 'baseline',
		width: '100%',
	},

	create: {
		flexDirection: 'row-reverse',
		display: 'flex',
		flexGrow: 1,
		marginRight: '20px',
	},

	createButton: {
		color: '#009AC9',
		cursor: 'pointer',
	},
});

export default styles;